import { useState, useEffect } from "react";
import instance from "helpers/instance";

function useServerTime() {
  const [todayVN, setTodayVN] = useState(null);

  useEffect(() => {
    instance
      .get("online/v1/server-time")
      .then((res) => {
        // server_time_vn: "2026-05-14T16:12:11+07:00" — extract date part
        const vn = res.data.server_time_vn;
        setTodayVN(vn.slice(0, 10));
      })
      .catch(() => {
        // fallback to local date in VN timezone
        setTodayVN(
          new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Ho_Chi_Minh" })
        );
      });
  }, []);

  return todayVN;
}

export default useServerTime;
